import type { PendingProvisionRow } from "@/lib/api/provisions";

export interface ReviewQueueGroup {
  documentId: string;
  documentTitle: string;
  provisions: PendingProvisionRow[];
}

/**
 * Groups pending provisions by their source document for the review-queue
 * page. Pure — no network — so the grouping/ordering behavior is unit
 * testable without mocking Supabase. Groups appear in the order their first
 * provision was encountered (callers pass rows pre-sorted by created_at, so
 * this reads as "oldest pending document first"); provisions within a group
 * keep their input order.
 */
export function groupProvisionsByDocument(
  provisions: readonly PendingProvisionRow[],
): ReviewQueueGroup[] {
  const groups: ReviewQueueGroup[] = [];
  const byDocument = new Map<string, ReviewQueueGroup>();

  for (const p of provisions) {
    const existing = byDocument.get(p.document_id);
    if (existing) {
      existing.provisions.push(p);
      continue;
    }
    const group: ReviewQueueGroup = {
      documentId: p.document_id,
      documentTitle: p.document_title,
      provisions: [p],
    };
    byDocument.set(p.document_id, group);
    groups.push(group);
  }

  return groups;
}
